import { useMemo } from 'react';

const { useMediaQuery } = require('@mui/material');

const useNavbarHeight = () => {
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('md'));

  const navbarHeight = useMemo(() => {
    return isMobile ? '72px' : '64px';
  }, [isMobile]);

  return navbarHeight;
};

export default useNavbarHeight;
